import { render, staticRenderFns } from "./ProductFilterList.vue?vue&type=template&id=68413e94&scoped=true&"
import script from "./ProductFilterList.vue?vue&type=script&lang=js&"
export * from "./ProductFilterList.vue?vue&type=script&lang=js&"
import style0 from "./ProductFilterList.vue?vue&type=style&index=0&id=68413e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68413e94",
  null
  
)

export default component.exports